import { FunctionComponent } from 'react';
import { cn } from '../../utilities/cn';

const RaptorToolTip: FunctionComponent<
  React.HTMLAttributes<HTMLSpanElement> & { text: string }
> = (props) => {
  return (
    <span
      className={cn(
        `absolute bottom-full left-1/2 z-10 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-mainblue px-2.5 py-1 text-xs font-bold text-white opacity-0 shadow-md transition-opacity group-hover:opacity-100`,
        props.className,
      )}
    >
      {props.text}
    </span>
  );
};

export default RaptorToolTip;
